import type { ListDealBase } from '@openx/types/deal';
import { useCallback } from 'react';

import { DealHealthScore, type DealHealthScoreValue } from './DealHealthScore';

type DealHealthScoreTableCellProps<T extends ListDealBase> = {
  deal: T;
  getHealthScoreForDeal: (deal: T) => DealHealthScoreValue;
  loadHealthScoreDetails: (deal: T) => void;
  reloadHealthScore: (deal: T) => void;
};

export const DealHealthScoreTableCell = <T extends ListDealBase>({
  deal,
  getHealthScoreForDeal,
  loadHealthScoreDetails,
  reloadHealthScore,
}: DealHealthScoreTableCellProps<T>) => {
  const handleOpen = useCallback(() => {
    loadHealthScoreDetails(deal);
  }, [deal, loadHealthScoreDetails]);

  const handleReload = useCallback(() => {
    reloadHealthScore(deal);
  }, [deal, reloadHealthScore]);

  return <DealHealthScore onOpen={handleOpen} onReload={handleReload} value={getHealthScoreForDeal(deal)} />;
};
